import React, { useState } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import InteractiveEmulationSection from './InteractiveEmulationSection';
import HowItWorks from './HowItWorks';
import ExampleCases from './ExampleCases';
import PricingSection from './PricingSection';
import Datasets from './Datasets';
import Principles from './Principles';
import Footer from './Footer';
import DotBackground from './DotBackground';
import CookieConsent from './CookieConsent';
import MaterializeForm from './MaterializeForm';

function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="app-container">
      <DotBackground />
      <Navbar onOpenModal={() => setIsModalOpen(true)} />
      <Hero onOpenModal={() => setIsModalOpen(true)} />
      <HowItWorks />
      <InteractiveEmulationSection />
      <ExampleCases />
      <PricingSection />
      <Datasets />
      <Principles />
      <Footer />
      <CookieConsent />
      <MaterializeForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default HomePage;

